module.exports = __webpack_public_path__ + "static/media/6ft.31805532.png";